import { render, staticRenderFns } from "./FullView.vue?vue&type=template&id=4531a868&scoped=true"
import script from "./FullView.vue?vue&type=script&lang=js"
export * from "./FullView.vue?vue&type=script&lang=js"
import style0 from "./FullView.vue?vue&type=style&index=0&id=4531a868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4531a868",
  null
  
)

export default component.exports